import React from "react";
import HeaderDefault from "./headers/HeaderDefault.jsx";
import HeaderICFF from "./headers/HeaderICFF.jsx";
import HeaderEnlace from "./headers/HeaderEnlace.jsx";

function Header({ componentType }) {
  const renderComponent = (type) => {
    switch (type) {
      case "default":
        return <HeaderDefault />;
      case "ICFF":
        return <HeaderICFF />;
      case "Enlace":
        return <HeaderEnlace />;
      default:
        return <></>;
    }
  };

  return <div>{renderComponent(componentType)}</div>;
}

export default Header;
